export const ActionTypes = {
  LOADING: "VER_OTP_LOADING",
  ERROR: "VER_OTP_ERROR",
  SUCCESS: "VER_OTP_SUCCESS",
};
